<script lang="ts">
	import GenericDisclosure from '$lib/components/GenericDisclosure.svelte';
	import { getTranslate } from '@tolgee/svelte';
	import FormFieldTextInput from '$lib/components/Form/FormFieldTextInput.svelte';
	import ButtonSecondary from '$lib/components/Button/ButtonSecondary.svelte';
	import { cart } from '$lib/store/cart.store';
	import {
		NOTIFICATION,
		NOTIFICATION_DURATION,
		notificationStore
	} from '$lib/store/notification.store';

	const { t } = getTranslate();

	let isOpen = false;

	let discountCodeValue = '';

	const updateCodeFromCart = (code: string) => {
		discountCodeValue = code;
	};

	$: if (($cart.data?.discountCodes.length ?? 0) > 0) {
		updateCodeFromCart($cart.data?.discountCodes?.[0]?.code || '');
	} else {
		updateCodeFromCart('');
	}

	const handleSubmit = async (e: SubmitEvent) => {
		const err = await cart.applyDiscount(discountCodeValue);
		if (err) {
			notificationStore.addNotification({
				actions: [{ text: $t('notification.close') }],
				hideAfter: NOTIFICATION_DURATION.LONG,
				text: $t(err),
				title: $t('cart.discountCode.error.title'),
				variant: NOTIFICATION.ALERT
			});
			return;
		}
		notificationStore.addNotification({
			actions: [{ text: $t('notification.close') }],
			hideAfter: NOTIFICATION_DURATION.LONG,
			text: $t('cart.discountCode.success.text'),
			title: $t('cart.discountCode.success.title'),
			variant: NOTIFICATION.SUCCESS
		});
	};

	const clearDiscounts = async () => {
		await cart.resetDiscounts();
	};
</script>

<GenericDisclosure bind:open={isOpen}>
	<button on:click={() => (isOpen = !isOpen)} class="flex justify-between items-center min-w-full">
		<h5>{$t('cart.discountCode.use')}</h5>
		<div
			class="i-sprenger-chevron-down bg-gray-700 transform transition duration-300"
			class:rotate-180={isOpen}
		></div>
	</button>
	<form on:submit|preventDefault={handleSubmit} action="#" slot="content-open">
		<FormFieldTextInput
			label={$t('cart.discountCode.title')}
			errors={[]}
			bind:value={discountCodeValue}
			name="code"
			type="text"
			class="mt-3"
			on:clear={() => clearDiscounts()}
			showClearButton={discountCodeValue !== ''}
		/>
		<ButtonSecondary text={$t('cart.discountCode.apply')} type="submit" class="w-full mt-4" />
	</form>
</GenericDisclosure>
